// menucomponent/CategorySection.js
// Updated isExpanded and isSubExpanded to default false (collapsed).

import React from "react";
import MenuItemCard from "./MenuItemCard";

export default function CategorySection({
  displayParents,
  filteredMenu,
  expandedCategories,
  toggleCategory,
  expandedSubCategories,
  toggleSubCategory,
  currentColValue,
  handleItemClick,
  colorsState,
  getCartQuantity,
  addToCart,
  removeFromCart
}) {
  return (
    <>
      {displayParents.map((parentCat) => {
        const itemsForParent = filteredMenu.filter(item => item.category === parentCat);
        if (itemsForParent.length === 0) return null;
        const isExpanded = !!expandedCategories[parentCat]; // Default false (collapsed)
        const subGroups = {};
        itemsForParent.forEach(item => {
          const sub = item.subCategory || "General";
          if (!subGroups[sub]) subGroups[sub] = [];
          subGroups[sub].push(item);
        });
        return (
          <React.Fragment key={parentCat}>
            <div className={`category-header ${isExpanded ? 'open' : ''}`} onClick={() => toggleCategory(parentCat)}>
              <h3 className="main-category-title">{parentCat}</h3>
              <span className="expand-icon">{isExpanded ? '−' : '+'}</span>
            </div>
            {isExpanded && Object.keys(subGroups).sort().map(sub => {
              const catItems = subGroups[sub];
              const isSubExpanded = !!expandedSubCategories[parentCat]?.[sub]; // Default false (collapsed)
              const gridColumns = catItems.length <= 1 ? 'repeat(1, 1fr)' : `repeat(${currentColValue}, 1fr)`;
              return (
                <React.Fragment key={sub}>
                  {sub !== "General" && (
                    <div className={`sub-category-header ${isSubExpanded ? 'open' : ''}`} onClick={() => toggleSubCategory(parentCat, sub)}>
                      <h4 className="sub-category-title">{sub}</h4>
                      <span className="expand-icon">{isSubExpanded ? '−' : '+'}</span>
                    </div>
                  )}
                  {isSubExpanded && (
                    <section className="menu-grid" style={{ gridTemplateColumns: gridColumns }}>
                      {catItems.map((item) => (
                        <MenuItemCard
                          key={item.name + item.price}
                          item={item}
                          handleItemClick={handleItemClick}
                          colorsState={colorsState}
                          getCartQuantity={getCartQuantity}
                          addToCart={addToCart}
                          removeFromCart={removeFromCart}
                        />
                      ))}
                    </section>
                  )}
                </React.Fragment>
              );
            })}
          </React.Fragment>
        );
      })}
    </>
  );
}